import React from "react";
import ArbeitsnachweisPa from "./ArbeitsnachweisPa";

export default function AdminPage() {
  return <ArbeitsnachweisPa adminOnly={true} />;
}
